import { Outlet } from 'react-router-dom'
import { AdminSidebar } from './AdminSidebar'
import { useAdminGuard } from './hooks/useAdminGuard'
import { LoadingScreen } from '../../components/LoadingScreen'

export const AdminShell = () => {
  const { isLoading, isSuperAdmin } = useAdminGuard()

  if (isLoading) return <LoadingScreen />
  if (!isSuperAdmin) return null  // guard is redirecting

  return (
    <div className="flex h-full bg-background">
      <AdminSidebar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}
